module.exports = __webpack_public_path__ + "static/media/BGSW_EAA_PZ_Multitenancy_AdminPortal_Delta4_3812_OSS_Scan_Report_2023_12_08.d6bd56a5.pdf";